import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { Userprofile } from "src/app/_models/Userprofile";
import { GetOwnUserProfile } from "src/app/_store/user-profile/user-profile.actions";
import { selectOwnUserProfile } from "src/app/_store/user-profile/user-profile.selectors";
import { Roles } from "src/app/constants/Roles";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"]
})
export class ContactUsComponent implements OnInit {
  userProfile$: Observable<Userprofile>;
  isLoggedIn: boolean = false;
  learnerRole: number = Roles.Learner;
  constructor(
    private authService: MsalService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this.hasLoggedInUser();

    if(this.isLoggedIn) {
      this.dispatchGetOwnUserProfile();
      this.selectOwnUserProfile();
    }
  }

  hasLoggedInUser(): boolean {
    return this.authService.instance.getAllAccounts().length > 0;
  }

  dispatchGetOwnUserProfile(): void {
    this.store.dispatch(GetOwnUserProfile());
  }

  selectOwnUserProfile(): void {
    this.userProfile$ = this.store.select(selectOwnUserProfile);
  }
}
